<template>
  <div class="avatar-wrapper">
    <v-avatar rounded :size="avatarSize" class="avatar-img">
      <v-img :src="avatarImageUrl"></v-img>
    </v-avatar>

    <div v-if="edit || create" class="avatar-actions">
      <v-btn
        color="primary"
        block
        @click="$refs.photo.click()"
        class="upload-btn"
      >
        <v-icon left>{{ icons.mdiCloudUploadOutline }}</v-icon>
        {{ $t("pages.upload_new_photo") }}
      </v-btn>
      <p class="upload-hint">Allowed JPG, GIF or PNG. Max size of 3MB</p>
    </div>

    <input
      ref="photo"
      type="file"
      accept=".jpeg,.png,.jpg,GIF"
      :hidden="true"
      @change="updateAvatar()"
    />
    <div v-if="showUploadProgress" class="upload-progress">
      Uploading: {{ uploadPercent }}%
    </div>
  </div>
</template>

<script>
import { mdiAlertOutline, mdiCloudUploadOutline } from "@mdi/js";
import { adminProfileStore } from "@/utils/helpers";
import axios from "axios";
import { Keys } from "/src/config.js";

export default {
  name: "AvatarImageComponent",
  props: ["avatarUrl", "user", "edit", "create"],
  setup() {
    return { adminProfileStore };
  },
  data() {
    return {
      uploadPercent: 0,
      defaultAvatar: "/storage/avatars/1/avatar.png",
      avatarImageUrl: "",
      showUploadProgress: false,
      processingUpload: false,
      icons: { mdiAlertOutline, mdiCloudUploadOutline },
      selected: false,
    };
  },
  computed: {
    avatarSize() {
      return this.$vuetify.breakpoint.smAndDown ? 100 : 120;
    },
  },
  mounted() {
    this.avatarImageUrl = this.avatarUrl
      ? Keys.VUE_APP_API_URL + this.avatarUrl
      : Keys.VUE_APP_API_URL + this.defaultAvatar;
  },
  methods: {
    updateAvatar() {
      if (!this.$refs.photo?.files?.[0]) return;
      if (this.create) {
        this.avatarImageUrl = URL.createObjectURL(this.$refs.photo.files[0]);
        this.$emit("avatar", this.$refs.photo.files[0]);
        this.selected = true;
        return;
      }
      this.showUploadProgress = true;
      this.processingUpload = true;
      this.uploadPercent = 0;
      let formData = new FormData();
      formData.append("avatar", this.$refs.photo.files[0]);
      axios
        .post("users/upload-avatar", formData, {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: (e) => {
            this.uploadPercent = e.lengthComputable
              ? Math.round((e.loaded * 100) / e.total)
              : 0;
          },
        })
        .then((response) => {
          this.avatarImageUrl =
            Keys.VUE_APP_API_URL + "/" + response.data.avatar_url;
          if (this.user.role_id == 1 || this.user.role_id == 2) {
            this.adminProfileStore.avatar = response.data.avatar_url;
          }
        })
        .finally(() => {
          this.showUploadProgress = false;
          this.processingUpload = false;
        });
    },
  },
};
</script>

<style scoped>
.avatar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.avatar-img {
  border: 3px solid #e0e0e0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
}
.avatar-actions {
  width: 100%;
  max-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.upload-btn {
  width: 100%;
}
.upload-hint {
  font-size: 11px;
  color: #9e9e9e;
  text-align: center;
  margin: 0;
}
.upload-progress {
  font-size: 13px;
  color: #1976d2;
}
</style>
